const _GRID = "GRID";
const _LIST = "LIST";

const adListView = Object.freeze({
  GRID: _GRID,
  LIST: _LIST,
});

export default adListView;
